import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SendIcon, BotIcon, SparklesIcon, ArrowLeftIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
export function AIBot() {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([{
    role: 'bot',
    content: '你好！我是育儿AI助手,有什么可以帮助你的吗?',
    timestamp: new Date()
  }]);
  const isHomePage = location.pathname === '/';
  const handleBackClick = () => {
    navigate(-1);
  };
  const handleSend = () => {
    if (message.trim()) {
      const newMessages = [...messages, {
        role: 'user',
        content: message,
        timestamp: new Date()
      }, {
        role: 'bot',
        content: '感谢您的提问!我正在学习中,很快就能更好地帮助您。',
        timestamp: new Date()
      }];
      setMessages(newMessages);
      setMessage('');
    }
  };
  const quickQuestions = ['宝宝几个月可以添加辅食?', '如何建立良好的睡眠习惯?', '宝宝发烧怎么办?', '如何进行早期教育?'];
  return <div className="flex flex-col h-screen bg-gradient-to-b from-indigo-50 to-purple-50" data-id="element-159">
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 shadow-lg" data-id="element-160">
        <div className="px-4 py-6" data-id="element-161">
          <div className="flex items-center relative" data-id="element-162">
            <button onClick={handleBackClick} className="absolute left-0 text-white transition-colors" data-id="element-163">
              <ArrowLeftIcon size={20} data-id="element-164" />
              <span className="text-xs font-medium" data-id="element-165">返回</span>
            </button>
            <div className="bg-white bg-opacity-20 p-3 rounded-2xl mr-4 ml-8" data-id="element-166">
              <BotIcon size={32} className="text-white" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <h1 className="text-2xl font-bold text-white" data-id="element-169">AI育儿助手</h1>
              <div className="flex items-center mt-1" data-id="element-170">
                <div className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse" data-id="element-171"></div>
                <p className="text-sm text-white opacity-90" data-id="element-172">在线服务中</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4 pb-32" data-id="element-173">
        {messages.length === 1 && <div className="mb-6" data-id="element-174">
            <div className="flex items-center justify-center mb-4" data-id="element-175">
              <SparklesIcon size={24} className="text-indigo-600 mr-2" data-id="element-176" />
              <h3 className="text-lg font-bold text-gray-800" data-id="element-177">快速提问</h3>
            </div>
            <div className="grid grid-cols-1 gap-2" data-id="element-178">
              {quickQuestions.map((question, index) => <button key={index} onClick={() => setMessage(question)} className="bg-white text-left p-4 rounded-xl shadow-sm border border-indigo-100 active:scale-98 transition-transform text-sm text-gray-700 hover:border-indigo-300" data-id="element-179">
                  {question}
                </button>)}
            </div>
          </div>}
        {messages.map((msg, index) => <div key={index} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'} animate-fadeIn`} data-id="element-180">
            <div className={`max-w-[85%] ${msg.role === 'user' ? 'order-2' : 'order-1'}`} data-id="element-181">
              <div className={`p-4 rounded-2xl ${msg.role === 'user' ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-br-none shadow-md' : 'bg-white text-gray-800 rounded-bl-none shadow-sm border border-gray-100'}`} data-id="element-182">
                <p className="text-sm leading-relaxed" data-id="element-183">{msg.content}</p>
              </div>
              <p className={`text-xs text-gray-500 mt-1 ${msg.role === 'user' ? 'text-right' : 'text-left'}`} data-id="element-184">
                {msg.timestamp.toLocaleTimeString('zh-CN', {
              hour: '2-digit',
              minute: '2-digit'
            })}
              </p>
            </div>
          </div>)}
      </div>
      <div className="fixed bottom-16 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg" data-id="element-185">
        <div className="flex items-end space-x-2 max-w-screen-sm mx-auto" data-id="element-186">
          <div className="flex-1" data-id="element-187">
            <textarea value={message} onChange={e => setMessage(e.target.value)} onKeyPress={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }} placeholder="输入您的问题..." rows={1} className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:outline-none focus:border-indigo-500 text-sm resize-none" style={{
            minHeight: '48px',
            maxHeight: '120px'
          }} data-id="element-188" />
          </div>
          <button onClick={handleSend} className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-3 rounded-2xl active:scale-95 transition-transform disabled:opacity-50 disabled:cursor-not-allowed shadow-md" disabled={!message.trim()} data-id="element-189">
            <SendIcon size={24} data-id="element-190" />
          </button>
        </div>
      </div>
      <BottomNav data-id="element-191" />
    </div>;
}